// Configuração das APIs - Arquitetura 2 Servidores
// Servidor 1 (195.35.40.29): Empresas
// Servidor 2 (62.72.63.93): PGFN, Sócios, CARF, IA

// Detectar ambiente
const isProduction = process.env.NODE_ENV === 'production';

// URLs configuradas para funcionar em produção e desenvolvimento
// Em produção: nginx no servidor 2 faz proxy para ambos os servidores
// Em desenvolvimento: acesso direto aos servidores
const SERVIDOR1_URL = process.env.REACT_APP_SERVIDOR1_URL || (isProduction ? '/api-empresas' : 'http://195.35.40.29:8000');
const SERVIDOR2_URL = process.env.REACT_APP_SERVIDOR2_URL || (isProduction ? '' : 'http://62.72.63.93:8001');

// Meilisearch
// Servidor 1: índice 'empresas'
// Servidor 2: índices 'pgfn_agregado', 'pgfn_dividas', 'socios', 'carf_julgamentos', 'carf_estoque'
const MEILISEARCH_SERVIDOR1 = process.env.REACT_APP_MEILISEARCH_URL || (isProduction ? '/servidor1' : 'http://195.35.40.29:7700');
const MEILISEARCH_SERVIDOR2 = isProduction ? '' : 'http://62.72.63.93:7700';
export const MEILISEARCH_KEY = process.env.REACT_APP_MEILISEARCH_KEY || 'masterKey';

// Endpoints do Servidor 1 (Empresas)
export const API_SERVIDOR1 = {
  BASE: SERVIDOR1_URL,
  SEARCH: `${SERVIDOR1_URL}/api/v1/search`,
  EMPRESA: (cnpj: string) => `${SERVIDOR1_URL}/api/v1/empresas/${cnpj}`,
  EMPRESA_COMPLETO: (cnpj: string) => `${SERVIDOR1_URL}/api/v1/empresas/${cnpj}/completo`,
  HEALTH: `${SERVIDOR1_URL}/health`,
};

// Endpoints do Servidor 2 (PGFN + Sócios)
export const API_SERVIDOR2 = {
  BASE: SERVIDOR2_URL,
  // Leads PGFN
  LEADS: `${SERVIDOR2_URL}/api/v1/leads`,
  LEADS_STATS: `${SERVIDOR2_URL}/api/v1/leads/stats`,
  // Carteira
  CARTEIRA: `${SERVIDOR2_URL}/api/v1/carteira`,
  CARTEIRA_STATUS: `${SERVIDOR2_URL}/api/v1/carteira/status`,
  // CNPJ completo (cross-server)
  CNPJ_COMPLETO: (cnpj: string) => `${SERVIDOR2_URL}/api/v1/cnpj/${cnpj}`,
  // PGFN
  PGFN_SEARCH: `${SERVIDOR2_URL}/api/v1/pgfn/search`,
  // Sócios
  SOCIOS_SEARCH: `${SERVIDOR2_URL}/api/v1/socios/search`,
  SOCIOS_CNPJ: (cnpj: string) => `${SERVIDOR2_URL}/api/v1/socios/cnpj/${cnpj}`,
  // Analytics
  TOP_DEVEDORES: `${SERVIDOR2_URL}/api/v1/analytics/top-devedores`,
  PRESTES_AJUIZAR: `${SERVIDOR2_URL}/api/v1/analytics/prestes-ajuizar`,
  HEALTH: `${SERVIDOR2_URL}/health`,
  // Produtos PGFN (4 produtos)
  PRODUTOS_DASHBOARD: `${SERVIDOR2_URL}/api/v1/produtos/dashboard`,
  PRODUTO_RADAR: `${SERVIDOR2_URL}/api/v1/produtos/radar`,
  PRODUTO_PRE_AJUIZAMENTO: `${SERVIDOR2_URL}/api/v1/produtos/pre-ajuizamento`,
  PRODUTO_AJUIZADOS: `${SERVIDOR2_URL}/api/v1/produtos/ajuizados-recentes`,
  PRODUTO_PRESCRICAO: `${SERVIDOR2_URL}/api/v1/produtos/prescricao`,
  // Worker e Score
  WORKER_ANALISE: (cnpj: string) => `${SERVIDOR2_URL}/api/v1/worker/analise/${cnpj}`,
  WORKER_HEALTH: `${SERVIDOR2_URL}/api/v1/worker/health`,
  // IA e RAG
  IA_RESUMO: (cnpj: string) => `${SERVIDOR2_URL}/api/v1/ia/resumo/${cnpj}`,
  IA_COMERCIAL: (cnpj: string) => `${SERVIDOR2_URL}/api/v1/ia/comercial/${cnpj}`,
  IA_JURIDICO: `${SERVIDOR2_URL}/api/v1/ia/juridico`,
  IA_JURIDICO_V2: `${SERVIDOR2_URL}/api/v1/ia/juridico/v2`,
  IA_PREDICAO: `${SERVIDOR2_URL}/api/v1/ia/predicao`,
  IA_ANALISE_COMPLETA: `${SERVIDOR2_URL}/api/v1/ia/analise-completa`,
  IA_LEGISLACAO: (tema: string) => `${SERVIDOR2_URL}/api/v1/ia/legislacao/${tema}`,
  // CARF
  CARF_SEARCH: `${SERVIDOR2_URL}/api/v1/carf/search`,
  // BI PGFN
  PGFN_BI: `${SERVIDOR2_URL}/api/v1/pgfn/bi`,
  PGFN_BI_TOP_UFS: `${SERVIDOR2_URL}/api/v1/pgfn/bi/top-ufs`,
  PGFN_BI_EVOLUCAO: `${SERVIDOR2_URL}/api/v1/pgfn/bi/evolucao`,
  PGFN_PRODUTOS_DASHBOARD: `${SERVIDOR2_URL}/api/v1/produtos/dashboard`,
};

// Endpoints Meilisearch direto
export const MEILISEARCH_ENDPOINTS = {
  // Empresas está no Servidor 1
  SEARCH_EMPRESAS: `${MEILISEARCH_SERVIDOR1}/indexes/empresas/search`,
  // Sócios está no Servidor 2
  SEARCH_SOCIOS: `${MEILISEARCH_SERVIDOR2}/indexes/socios/search`,
};

// Helper para detectar ambiente (exportado)
export const isProd = isProduction;
export const isDevelopment = process.env.NODE_ENV === 'development';
